
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 54 54","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"filter":"url(#filter0_d_284_637)"}},[_c('circle',{attrs:{"cx":"27","cy":"26","r":"21","fill":"currentColor"}})]),_c('path',{staticClass:"plus-icon",attrs:{"d":"M24.357 15.449h5.727v21.954h-5.727z"}}),_c('path',{staticClass:"plus-icon",attrs:{"d":"M38.195 23.64v5.726H16.24V23.64z"}}),_c('defs',[_c('filter',{attrs:{"id":"filter0_d_284_637","x":".172","y":".337","width":"53.657","height":"53.657","filterUnits":"userSpaceOnUse","color-interpolation-filters":"sRGB"}},[_c('feFlood',{attrs:{"flood-opacity":"0","result":"BackgroundImageFix"}}),_c('feColorMatrix',{attrs:{"in":"SourceAlpha","values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0","result":"hardAlpha"}}),_c('feOffset',{attrs:{"dy":"1.166"}}),_c('feGaussianBlur',{attrs:{"stdDeviation":"2.914"}}),_c('feComposite',{attrs:{"in2":"hardAlpha","operator":"out"}}),_c('feColorMatrix',{attrs:{"values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"}}),_c('feBlend',{attrs:{"in2":"BackgroundImageFix","result":"effect1_dropShadow_284_637"}}),_c('feBlend',{attrs:{"in":"SourceGraphic","in2":"effect1_dropShadow_284_637","result":"shape"}})])])])
          )
        }
      }
    